export const closedFlapBackground =
  "transparent linear-gradient(0deg, #cceefc 0%, #b9e6fb 100%) 0% 0% no-repeat padding-box";
export const openFlapBackground =
  "transparent linear-gradient(0deg, #e1f4fd 0%,  #FFFFFF 100%) 0% 0% no-repeat padding-box";
